import { css } from '@/styled-system/css';

export const detailLabelStyles = css.raw({
  gridColumnEnd: 'span 4',
});

export const detailValueStyles = css.raw({
  gridColumnEnd: 'span 8',
});

export const categoryValueStyles = css.raw({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '200',
});
